import React from 'react';
import { CheckCircle2Icon, AwardIcon, UsersIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function About() {
  const benefits = ['Fully Licensed, Bonded, and Insured in California', 'Years of experience handling complex documents', 'Deeply rooted in the local Fresno community', 'Commitment to accuracy and attention to detail'];
  return <section id="about" className="py-24 bg-slate-50 relative overflow-hidden" data-id="element-9">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-blue-50/50 skew-x-12 translate-x-1/4 -z-10" data-id="element-10" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-12">
          {/* Image Side */}
          <FadeIn direction="right" data-id="element-13">
            <div className="relative" data-id="element-14">
              <div className="aspect-square md:aspect-[4/3] lg:aspect-square rounded-2xl overflow-hidden shadow-xl relative z-10" data-id="element-15">
                <div className="absolute inset-0 bg-blue-900/10 mix-blend-multiply z-10" data-id="element-16" />
                <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Friendly Fresno Notary Professional" className="w-full h-full object-cover" data-id="element-17" />
              </div>

              {/* Stats Card */}
              <div className="absolute -bottom-8 -right-8 md:bottom-8 md:-right-8 bg-white p-6 rounded-xl shadow-xl z-20 border border-slate-100 max-w-xs" data-id="element-18">
                <div className="flex items-center gap-4 mb-2" data-id="element-19">
                  <div className="bg-blue-100 p-2 rounded-lg text-blue-700" data-id="element-20">
                    <AwardIcon className="w-6 h-6" data-id="element-21" />
                  </div>
                  <div className="text-3xl font-bold text-slate-900" data-id="element-22">100%</div>
                </div>
                <p className="text-sm font-medium text-slate-600" data-id="element-23">
                  Satisfaction Guarantee on all notarizations
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Content Side */}
          <FadeIn direction="left" data-id="element-24">
            <p className="text-blue-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-25">
              Why Choose a Notary
            </p>
            <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-6 leading-tight" data-id="element-26">
              Professional{' '}
              <span className="text-gradient" data-id="element-27">Notary Services</span> in Fresno
            </h2>

            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-28">
              Finding a trustworthy{' '}
              <strong className="font-medium text-slate-800" data-id="element-29">
                notary public in Fresno, California
              </strong>{' '}
              is crucial for your important life events and business
              transactions. Whether you're in Old Fig Garden closing on a home,
              in Sunnyside handling estate documents, or anywhere in Northwest
              Fresno, we pride ourselves on delivering exceptional service with
              a personal touch.
            </p>

            <div className="space-y-4 mb-10" data-id="element-30">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-31">
                  <CheckCircle2Icon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-0.5" data-id="element-32" />
                  <span className="text-slate-700 font-medium" data-id="element-33">{benefit}</span>
                </div>)}
            </div>

            <div className="grid grid-cols-2 gap-6 pt-8 border-t border-slate-200" data-id="element-34">
              <div data-id="element-35">
                <div className="text-3xl font-bold text-blue-900 mb-1" data-id="element-36">5+</div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-37">
                  Years Experience
                </div>
              </div>
              <div data-id="element-38">
                <div className="flex items-center gap-2 mb-1" data-id="element-39">
                  <UsersIcon className="w-8 h-8 text-blue-900" data-id="element-40" />
                  <span className="text-3xl font-bold text-blue-900" data-id="element-41">
                    Local
                  </span>
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-42">
                  Fresno Community
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}